const tables = document.querySelectorAll('.txt table');

tables.forEach(table => {
    table.classList.add('table', 'table-sm');
});
